<template>
  <div class="flex items-center">
    <div class="w-7 h-7 shrink-0">
      <component :is="icon" />
    </div>
    <a
      v-if="!disable"
      :href="url"
      class="p-2 rounded-md hover:bg-gray-100 flex items-center gap-2"
      >
      {{ appName }}
    </a>
    <div
      v-else
      class="p-2 rounded-md hover:bg-gray-50 opacity-70 cursor-not-allowed flex items-center gap-2"
    >
      {{ appName }}
    </div>
  </div>
</template>

<script setup>
  defineProps( {
    appName: { String, required: true },
    url: { String, required: true },
    icon: { Object, required: true },
    disable: { Boolean, default: false }
  } );
</script>